import React, { PropTypes } from 'react';

const LanguageTag = ({ code, abbreviations }) => {
  const language = abbreviations[code];
  if (!code || !language) {
    return null;
  }

  return (<span className="tag tag-default tag-sm language-tag">
    { language }
  </span>);
};

const Languages = ({ primary_lang, additional_lang_1, abbreviations }) => {
  // return nothing if user speaks no languages
  if (!primary_lang && !additional_lang_1) {
    return null;
  }

  return (
    <div className="profile-languages">
      <h4>Speaks</h4>
      <LanguageTag code={primary_lang} abbreviations={abbreviations} />
      <LanguageTag code={additional_lang_1} abbreviations={abbreviations} />
    </div>);
};

LanguageTag.propTypes = {
  code: PropTypes.string,
  abbreviations: PropTypes.object,
};

Languages.propTypes = {
  primary_lang: PropTypes.string,
  additional_lang_1: PropTypes.string,
  abbreviations: PropTypes.object,
};

export { LanguageTag };
export default Languages;



// WEBPACK FOOTER //
// ./profile/components/languages.jsx